import * as React from 'react'
import { Badge, Box } from '@mui/material';

import {NotAllowedBlock} from "@components";
import {STOCK_STATUS} from "../../@constants";


export default function numVariantsColumn() {
    return {
        name: 'numVariants', label: 'Num Variants',
        options: {
            customBodyRowRenderLite: (value, row) => <Box display={'flex'} justifyContent={'center'}>
                {row.stock === STOCK_STATUS.STOCK && <Badge badgeContent={value} color="primary"/>}
                {row.stock === STOCK_STATUS.OUT_OF_STOCK && <NotAllowedBlock />}
            </Box>
        }
    }
}

